import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '第1条（適用）',
    content: `本規約は、GRAINN（以下「当社」）が提供するウェブサイト制作・SNS運用代行・デジタルマーケティング支援サービス（以下「本サービス」）の利用に関して、当社とお客様（以下「ユーザー」）との間の権利義務関係を定めるものです。本サービスをご利用いただく前に、本規約をよくお読みください。`,
  },
  {
    title: '第2条（サービス内容）',
    content: `当社が提供する主なサービスは以下のとおりです。\n・WEBサイトの企画・デザイン・制作・保守管理\n・SNS（Instagram・X・Facebookなど）の運用代行\n・デジタルマーケティング戦略の立案・実施支援\n・その他、当社が別途定めるサービス`,
  },
  {
    title: '第3条（利用申込と契約成立）',
    content: `サービスの利用申込は、お問い合わせフォームまたはメール・電話にて受け付けます。当社が申込内容を確認し、承諾の意思表示を行った時点で契約が成立するものとします。当社は、以下の場合に申込を拒否することがあります。\n・過去に本規約違反があった場合\n・申込内容に虚偽・誤記が含まれる場合\n・その他当社が不適切と判断した場合`,
  },
  {
    title: '第4条（料金・支払い）',
    content: `サービス料金は、別途提示する見積書・契約書に基づきます。支払い方法・支払いタイミングは、個別契約にて定めるものとします。なお、料金は予告なく変更される場合があります。変更の際は事前にご連絡します。`,
  },
  {
    title: '第5条（キャンセル・返金）',
    content: `契約後のキャンセルについては、個別契約に定めるキャンセルポリシーに従います。制作着手後のキャンセルの場合、着手済みの作業に対する費用が発生する場合があります。詳細は個別契約書をご確認ください。`,
  },
  {
    title: '第6条（知的財産権）',
    content: `当社が制作した成果物の著作権は、制作料金の完済をもってユーザーに譲渡されます。ただし、当社が制作に使用した素材・ツール・フレームワーク等のライセンスについては各ライセンス条項に従います。また、当社のポートフォリオ・実績紹介として、成果物を掲載することをユーザーは予め承諾するものとします。`,
  },
  {
    title: '第7条（禁止事項）',
    content: `ユーザーは、本サービスの利用にあたり以下の行為を行ってはなりません。\n・法令または公序良俗に違反する行為\n・当社または第三者の権利・利益を侵害する行為\n・本サービスの運営を妨害する行為\n・虚偽の情報を提供する行為\n・その他、当社が不適切と判断する行為`,
  },
  {
    title: '第8条（免責事項）',
    content: `当社は、本サービスの提供に関して最善を尽くしますが、成果物の効果・成果を保証するものではありません。本サービスの利用によりユーザーに生じた損害について、当社の故意または重大な過失による場合を除き、責任を負いません。`,
  },
  {
    title: '第9条（個人情報の取り扱い）',
    content: `ユーザーの個人情報の取り扱いについては、別途定める「プライバシーポリシー」に従います。`,
  },
  {
    title: '第10条（規約の変更）',
    content: `当社は、必要と判断した場合に本規約を変更できるものとします。変更後の規約は、本サイト上に掲載した時点から効力を発するものとし、ユーザーは定期的に確認する義務を負います。`,
  },
  {
    title: '第11条（準拠法・管轄裁判所）',
    content: `本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して生じた紛争については、大阪地方裁判所を第一審の専属的合意管轄裁判所とします。`,
  },
];

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="min-h-screen">
      <title>利用規約｜GRAINN</title>
      <meta name="description" content="GRAINNの利用規約。サービス内容・料金・支払い・キャンセル・知的財産権・禁止事項・免責事項など、サービス利用に関する規定をご確認ください。" />
      <meta name="robots" content="noindex, follow" />
      <Navbar />

      {/* Page Hero */}
      <section
        className="relative pt-44 pb-24 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #0A2A6E 0%, #0D3A8E 50%, #1557C0 100%)' }}
      >
        <div className="absolute inset-0">
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(10,42,110,0.5), rgba(10,42,110,0.82))' }} />
        </div>
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.35) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
          <p className="text-[#93C5FD] text-xs tracking-[0.4em] mb-5 uppercase">/ Terms of Service</p>
          <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight leading-tight mb-6">
            利用規約
          </h1>
          <div className="w-16 h-px mb-6" style={{ background: 'linear-gradient(90deg, #60A5FA, transparent)' }} />
          <p className="text-white/70 text-base max-w-xl leading-relaxed">
            本サービスをご利用いただく前に、以下の利用規約をご確認ください。
          </p>
          <div className="flex items-center gap-2 mt-8 text-xs text-white/40">
            <Link to="/" className="hover:text-white/70 transition-colors">ホーム</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/70">利用規約</span>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20" style={{ background: '#F5F8FF' }}>
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="bg-white rounded-2xl p-8 md:p-12 mb-8" style={{ border: '1px solid rgba(30,111,255,0.08)' }}>
            <p className="text-sm text-[#888] leading-relaxed mb-2">制定日：2026年1月1日</p>
            <p className="text-sm text-[#888] leading-relaxed">最終改定：2026年1月1日</p>
            <p className="text-sm text-[#555] leading-relaxed mt-6">
              本利用規約（以下「本規約」）は、GRAINN が提供するすべてのサービスに適用されます。サービスをご利用いただくことで、本規約に同意したものとみなします。
            </p>
          </div>

          <div className="space-y-6">
            {sections.map((section) => (
              <div key={section.title} className="bg-white rounded-2xl p-8 md:p-10" style={{ border: '1px solid rgba(30,111,255,0.08)' }}>
                <h2 className="text-base font-bold text-[#0A1628] mb-4 flex items-center gap-3">
                  <span className="w-1.5 h-5 rounded-full inline-block" style={{ background: 'linear-gradient(180deg, #1E6FFF, #0099FF)' }} />
                  {section.title}
                </h2>
                <p className="text-sm text-[#555] leading-relaxed whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-8 bg-white rounded-2xl p-8 md:p-10 text-center" style={{ border: '1px solid rgba(30,111,255,0.08)' }}>
            <p className="text-sm text-[#888]">
              本規約に関するお問い合わせは、
              <Link to="/contact" className="text-[#1E6FFF] hover:underline mx-1 font-medium">
                お問い合わせページ
              </Link>
              よりご連絡ください。
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16" style={{ background: '#F5F8FF' }}>
        <div className="max-w-2xl mx-auto px-6 text-center">
          <p className="text-[#888] text-sm mb-6">
            ご不明な点はお気軽にお問い合わせください。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 text-white px-10 py-4 rounded-full text-sm tracking-widest font-bold hover:opacity-90 hover:scale-105 transition-all duration-300 whitespace-nowrap"
            style={{ background: 'linear-gradient(90deg, #1E6FFF 0%, #0099FF 100%)' }}
          >
            <i className="ri-mail-send-line" />
            お問い合わせはこちら
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
